module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/transbanklogo.4e55d4d6.svg";